import { useState, type PropsWithChildren } from 'react';
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider as TanStackQueryClientProvider,
} from '@tanstack/react-query';

import { useCommonModal } from 'renderer/components/CommonModal/context';

export const QueryClientProvider = ({ children }: PropsWithChildren) => {
  const { openModal } = useCommonModal();

  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error, query) => {
            const modal = query.meta?.getErrorModal?.({ error });

            if (modal) openModal(modal);
          },
        }),
        mutationCache: new MutationCache({
          onError: (error, variables, context, mutation) => {
            const modal = mutation.meta?.getErrorModal?.({ error, variables, context });

            if (modal) openModal(modal);
          },
        }),
      }),
  );

  return <TanStackQueryClientProvider client={queryClient}>{children}</TanStackQueryClientProvider>;
};

export default QueryClientProvider;
